import { inputBaseClasses } from '@mui/material';
import { getButtonAndInputBoxShadow, getButtonAndInputBoxShadowFocused, getErrorInputBoxShadow, getErrorInputBoxShadowFocused, } from '../shadows';
import { pickersOutlinedInputClasses } from '@mui/x-date-pickers';
export const MuiOutlinedInput = {
    styleOverrides: {
        root: ({ theme }) => [
            {
                ...getOutlinedInputRootStyles(theme),
                // Adornment color only
                color: theme.palette.text.muted,
                '&.Mui-disabled': {
                    backgroundColor: theme.palette.background.light,
                },
                'input[type="search"]::-webkit-search-cancel-button': {
                    appearance: 'none',
                    height: '16px',
                    width: '16px',
                    marginLeft: '.4rem',
                    backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>")`,
                    cursor: 'pointer',
                },
                // TODO: check if it is working after MUI V7 -> V9 upgrade
                [`&.${inputBaseClasses.sizeSmall} > .${inputBaseClasses.input}`]: {
                    paddingTop: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                },
            },
        ],
        notchedOutline: ({ theme }) => getOutlinedInputNotchedOutlineStyles(theme),
        input: ({ theme }) => ({
            padding: theme.spacing(1.5, 3),
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
            paddingRight: theme.spacing(3),
            paddingLeft: theme.spacing(3),
        }),
        multiline: ({ theme }) => ({
            padding: theme.spacing(1, 0),
        }),
    },
};
export const MuiPickersOutlinedInput = {
    styleOverrides: {
        root: ({ theme }) => [
            getOutlinedInputRootStyles(theme),
            // This part is necessary here because of focused part is not working (bug MUI v9.3.1). see comment below
            {
                [`&.Mui-focused .${pickersOutlinedInputClasses.notchedOutline}`]: {
                    borderWidth: 0,
                },
            },
        ],
        notchedOutline: ({ theme }) => getOutlinedInputNotchedOutlineStyles(theme),
        // is not working (bug MUI v9.3.1) (see comment above)
        // focused: ({ theme }) => ({
        // 	[`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
        // 		borderWidth: 0,
        // 	},
        // }),
        sectionsContainer: ({ theme }) => ({
            color: theme.palette.text.primary,
            padding: theme.spacing(2, 0),
        }),
    },
};
const getOutlinedInputRootStyles = (theme) => ({
    height: 'fit-content',
    backgroundColor: theme.palette.background.paper,
});
const getOutlinedInputNotchedOutlineStyles = (theme) => [
    {
        border: 0,
        boxShadow: getButtonAndInputBoxShadow(theme),
        '.Mui-error &': {
            borderRadius: theme.shape.borderRadius,
            boxShadow: getErrorInputBoxShadow(theme),
        },
        '.Mui-focused &': {
            boxShadow: getButtonAndInputBoxShadowFocused(theme),
        },
        '.Mui-focused.Mui-error &': {
            boxShadow: getErrorInputBoxShadowFocused(theme),
        },
    },
    theme.applyStyles('dark', {
        backgroundColor: `color-mix(in oklab, ${theme.vars.palette.zinc[200]} 15%, transparent)`,
    }),
];
